"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useResizeObserver = require("./useResizeObserver");
Object.keys(_useResizeObserver).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useResizeObserver[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useResizeObserver[key];
    }
  });
});